import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ResourceService } from './resource.service';

@Injectable()
export class WindowUnloadService {

    private subs: any[] = [];

    constructor(private res: ResourceService) {
        window.onbeforeunload = e => {
            if (this.anyUnfinishedBusiness()) {
                const msg = this.res.Localize("Confirm_Close");
                return msg;
            }
        };
    }

    public subscribe(fun: Function) {
        if (typeof fun !== 'function') return;

        this.subs.push(fun);
        return {
            unsubscribe: () => {
                this.unsubscribe(fun);
            }
        }
    }

    public unsubscribe(fun: Function) {
        const index = this.subs.findIndex(x => x == fun);
        if (index > -1) {
            this.subs.splice(index, 1);
        }
    }

    private anyUnfinishedBusiness() {
        for (const sub of this.subs) {
            if (sub && sub()) {
                return true;
            }
        }

        return false;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/window-unload.service.ts